/**
 * Triggers a download of the given content with the specified filename
 */
export function downloadFile(content: string | Uint8Array, filename: string, mimeType: string): void {
    const blob = new Blob([content as BlobPart], { type: mimeType });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}

/**
 * Downloads SVG content as an SVG file
 */
export function downloadSVG(svgContent: string, filename: string = 'diagram.svg'): void {
    downloadFile(svgContent, filename, 'image/svg+xml');
}

/**
 * Downloads PDF content as a PDF file
 */
export function downloadPDF(pdfBytes: Uint8Array, filename: string = 'diagram.pdf'): void {
    downloadFile(pdfBytes, filename, 'application/pdf');
}

/**
 * Converts SVG to PNG and downloads it
 */
export function downloadPNG(svgContent: string, filename: string = 'diagram.png'): Promise<void> {
    return new Promise((resolve, reject) => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) {
            reject(new Error('Could not get canvas context'));
            return;
        }

        const img = new Image();

        img.onload = function () {
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0);

            canvas.toBlob(
                function (blob) {
                    if (!blob) {
                        reject(new Error('Failed to create blob'));
                        return;
                    }

                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url);
                    resolve();
                },
                'image/png'
            );
        };

        img.onerror = function () {
            reject(new Error('Failed to load SVG image'));
        };

        const svgBlob = new Blob([svgContent], { type: 'image/svg+xml' });
        const svgUrl = URL.createObjectURL(svgBlob);
        img.src = svgUrl;
    });
}
